import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store/store'
import {
  resetColorPickerSuggestion,
  setColorPicker,
  setColorPickerSuggestion,
} from '../../store/modules/colorPickerButton/slice'
import { ColorPickerButton, IPreviousColorPickerButtonData } from './types'

export interface ISavedColor {
  key: string
  color: string
}

export const useColorPickerButton = () => {
  const { current: currentColors } = useSelector<RootState, ColorPickerButton>(
    (state) => state.colorPickerButton
  )

  const dispatch = useDispatch()

  const handleSaveColor = (key: string, color: string) => {
    dispatch(setColorPicker({ key, color }))
  }

  const handlerApplySuggestion = (data: IPreviousColorPickerButtonData) => {
    dispatch(setColorPickerSuggestion(data))
  }

  const handlerResetSuggestion = () => {
    dispatch(resetColorPickerSuggestion())
  }

  return {
    handleSaveColor,
    handlerApplySuggestion,
    handlerResetSuggestion,
    colors: currentColors,
  }
}
